import type { IsAutosaveBlockedOptions } from "src/redux/selectors/selectIsAutosaveBlocked";
import { setEditing } from "src/redux/slices/entrySlice";
import type { AppDispatch } from "src/redux/store";

type ScheduleHandler = (options?: IsAutosaveBlockedOptions) => void;

let scheduleHandler: ScheduleHandler | null = null;

export function registerAutosaveScheduleHandler(handler: ScheduleHandler) {
  scheduleHandler = handler;
  return () => {
    if (scheduleHandler === handler) {
      scheduleHandler = null;
    }
  };
}

export function requestAutosaveSchedule(options?: IsAutosaveBlockedOptions) {
  scheduleHandler?.(options);
}

export function triggerAutosaveForExternalChange(
  dispatch: AppDispatch,
  options?: IsAutosaveBlockedOptions,
) {
  dispatch(setEditing(true));
  requestAutosaveSchedule(options);
}
